/**
 * General Ledger (BE-33) — real API.
 *
 * One GL account's opening balance, every posted line with the running balance after it, and its closing balance
 * (balances on one side: `{ debit, credit }`, the other null). `account` is the GL account number; `to` defaults to today
 * and `from` to the first day of its month. P&L accounts and retained earnings stay within one calendar year.
 */

import ApiService from '../api.service';
import { unwrapData } from '../../utils/apiConvert';

export const generalLedgerService = {
  // account number; from / to as YYYY-MM-DD
  get: async ({ account, from, to } = {}) =>
    unwrapData(await ApiService.get('/api/reports/general-ledger', {
      params: Object.fromEntries(Object.entries({ account, from, to }).filter(([, v]) => v)),
    })),
};

export default generalLedgerService;
